import { useQuery } from "@tanstack/react-query"
import { ModernCard, ModernCardHeader, ModernCardContent } from "@/components/ui/modern-card"

export default function SurveysPage() {
  const { data: summary } = useQuery<{ summary: { total: number; prefBJP: number; prefADMK: number; issuesReported: number } }>({
    queryKey: ["/api/surveys/summary"],
  })
  const { data: recent } = useQuery<{ verifications: any[] }>({
    queryKey: ["/api/surveys/recent"],
  })

  return (
    <div className="min-h-screen p-4 space-y-6">
      <ModernCard>
        <ModernCardHeader>
          <span>Survey Summary</span>
        </ModernCardHeader>
        <ModernCardContent>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="border rounded-xl p-4">
              <div className="text-sm text-gray-500">Total</div>
              <div className="text-2xl font-bold">{summary?.summary.total || 0}</div>
            </div>
            <div className="border rounded-xl p-4">
              <div className="text-sm text-gray-500">BJP Preference</div>
              <div className="text-2xl font-bold">{summary?.summary.prefBJP || 0}</div>
            </div>
            <div className="border rounded-xl p-4">
              <div className="text-sm text-gray-500">ADMK Preference</div>
              <div className="text-2xl font-bold">{summary?.summary.prefADMK || 0}</div>
            </div>
            <div className="border rounded-xl p-4">
              <div className="text-sm text-gray-500">Issues Reported</div>
              <div className="text-2xl font-bold">{summary?.summary.issuesReported || 0}</div>
            </div>
          </div>
        </ModernCardContent>
      </ModernCard>

      <ModernCard>
        <ModernCardHeader>
          <span>Recent Verifications</span>
        </ModernCardHeader>
        <ModernCardContent>
          <div className="space-y-3">
            {recent?.verifications?.map((v, i) => (
              <div key={i} className="border rounded-xl p-4">
                <div className="text-sm">Status: <span className="font-medium">{v.status}</span></div>
                {v.notes && (<div className="text-sm text-gray-600">{v.notes}</div>)}
              </div>
            ))}
          </div>
        </ModernCardContent>
      </ModernCard>
    </div>
  )
}

